module.exports = __webpack_public_path__ + "static/princess-cruises-0a6b81e55b55e8f9918654ad5fd32c5d.svg";